<template>
  <div class="news-detail-container">
    <div class="section-container">
      <el-row>
        <el-col :span="4">&nbsp;</el-col>
        <el-col :span="16">
          <div class="news-info-box">
            <div class="news-title">
              <p>{{ detail.title }}</p>
            </div>
            <div class="news-time-box">
              <span class="news-type">{{ detail.type }}</span>
              <span>&nbsp;&nbsp;</span>
              <span class="news-date">{{ detail.time }}</span>
            </div>

            <div v-html="detail.detail" class="news-content-box"></div>
          </div>
        </el-col>
        <el-col :span="4">&nbsp;</el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "NewsDetail",
  data() {
    return {
      detail: {},
    };
  },
  methods: {
    getDetail() {
      const { id } = this.$route.params;
      const detail = require(`./json/${id}.json`);
      this.detail = detail;
    },
  },
  mounted() {
    this.getDetail();
  },
};
</script>
<style lang="scss">
.news-detail-container {
  .new-info-box {
    box-sizing: border-box;
    padding-top: 50px;
  }

  .news-info-box {
    margin-left: auto;
    margin-right: auto;
    padding-top: 50px;
  }

  .news-title {
    font-size: 35px;
    color: #3c4347;
    text-align: justify;
  }

  .news-title > p {
    font-size: 28px !important;
    font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei",
      "\9ED1\4F53", Arial, sans-serif !important;
  }

  .news-time-box {
    margin-top: 16px;
    color: #3c4347;
    font-size: 22px;
    text-align: justify;
  }

  .news-time-box span {
    font-size: 14px !important;
    color: #008748 !important;
    font-weight: 400 !important;
    font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei",
      "\9ED1\4F53", Arial, sans-serif !important;
  }

  .news-digest-box {
    margin-top: 35px;
    color: #3c4347;
    font-size: 22px;
    text-align: justify;
  }

  .news-digest-box > p {
    font-size: 19px !important;
    font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei",
      "\9ED1\4F53", Arial, sans-serif !important;
  }

  .news-content-box {
    color: #3c4347;
    font-size: 18px;
    margin-top: 50px;
  }

  .news-content-box a {
    color: #3c4347 !important;
    font-size: 18px !important;
    margin-top: 50px !important;
  }

  .news-content-box a:hover {
    color: #008748 !important;
  }

  .news-content-box > img,
  .news-content-box > p > img,
  .news-content-box > span > img {
    /*margin-bottom: 24px;*/
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .news-content-box img {
    height: auto !important;
    width: 100% !important;
    display: block !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  video {
    width: 100% !important;
  }

  .news-content-box span,
  .news-content-box strong,
  .news-content-box p {
    font-size: 16px !important;
    color: #565c61 !important;
    background: transparent !important;
    line-height: 28px !important;
    font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei",
      "\9ED1\4F53", Arial, sans-serif !important;
  }

  hr {
    margin-top: 20px;
    margin-bottom: 20px;
    border: 0;
    border-top: 1px solid #eee;
  }
}
</style>
